import React, { useState } from "react";
import fetchData from "../../api/fetchApi";
import { useNavigate } from "react-router-dom";

export default function AddPackagePage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    package_name: "",
    price: "",
    validity: "",
    visible: false,
    currency_symbol: "LYD"
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const body = {
        ...form,
        visible: form.visible ? "1" : "0"
      };
      await fetchData("chaat/packages", "POST", body);
      setSuccess("تمت إضافة الباقة بنجاح!");
      setTimeout(() => navigate("/admin/packages"), 1200);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء الإضافة");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white rounded-2xl shadow">
      <h2 className="text-xl font-bold mb-4">إضافة باقة جديدة</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          name="package_name"
          value={form.package_name}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="اسم الباقة"
          required
        />
        <input
          name="price"
          value={form.price}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="السعر"
          required
        />
        <input
          name="validity"
          value={form.validity}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="المدة (بالأيام)"
          type="number"
          required
        />
        <input
          name="currency_symbol"
          value={form.currency_symbol}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="رمز العملة"
          required
        />
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            name="visible"
            checked={form.visible}
            onChange={handleChange}
          />
          <span>مرئي</span>
        </label>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow"
          disabled={loading}
        >
          {loading ? "جاري الإضافة..." : "إضافة"}
        </button>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {success && <div className="text-green-600 text-sm">{success}</div>}
      </form>
    </div>
  );
}
